import { CommonModule } from '@angular/common';
import { Component, input, output } from '@angular/core';
import { DevToolsService } from '@commons/services/dev-tools.service';

@Component({
  selector: 'app-capital-container',
  imports: [CommonModule],
  templateUrl: './capital-container.html',
  styleUrl: './capital-container.scss',
})
export class CapitalContainer {
  disablePaddings = input<boolean>(false);
  width = input<string>("78%");
  size = input<string>("L");
  compactTop = input<boolean>(false);
  
  devToolsUnlocked = output<boolean>();
  
  constructor(private readonly devToolsService: DevToolsService) {}

  onLogoClick() {
    const unlocked = this.devToolsService.onLogoClick();
    if (unlocked) {
      this.devToolsUnlocked.emit(true);
    }
  }
}
